import { ContainerComponent, wrap } from 'AppReact';
import {
  FlexCenterWrapper, CursorPointerWrapper, Mr3, FitRelativeWrapper,
  AbsoluteLeftTopWrapper, CustomBorderWrapper, FilterHeaderWrapper,
  Mr2, P3, Mt4, FlexCenterJustifyEndWrapper, Width350
} from 'wrappers';
import { Icon, SecondaryTextSm, PrimaryTextSm, SecondaryTextXs } from 'atoms';
import { IconTextButton } from 'molecules';
import {
  MoreFiltersSvg,
  WarningTriangleSvg,
  TrashBinSvg
} from 'components/icons';
import React from 'react';
import internalState from './internalState';
import Controller from './controller';
import BoxDropdown from '../boxDropdown';
import { Checkbox } from "molecules";

const containerRef = React.createRef();

export const definition = {
  name: 'InspectionFilters',
  controller: Controller,
  initialProps: ({
    dueDates,
    selectedDueDateIds,
    hasExportError

  }) => ({
    dueDates,
    selectedDueDateIds,
    hasExportError
  }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      ref: containerRef,
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
          name: 'HeaderWrapper',
          isButton: true,
          bindings: ({
            isOpen,
            dueDates,
            selectedDueDateIds
          }) => ({
            isOpen,
            containerRef,
            dueDates,
            selectedDueDateIds
          }),
          elements: [
            {
              component: wrap(Icon, Mr3),
              name: 'Icon',
              displayValue: ({ isOpen, selectedDueDateIds }) => MoreFiltersSvg({ color: isOpen || selectedDueDateIds?.length > 0 ? window?.settings?.primary_color : window?.settings?.secondary_color })
            },
            {
              component: wrap(SecondaryTextSm, Mr3),
              renderIf: ({ isOpen, selectedDueDateIds }) => !isOpen && selectedDueDateIds?.length === 0,
              name: 'Text',
              displayValue: ({ }) => 'Filters'
            },
            {
              component: wrap(PrimaryTextSm, Mr3),
              renderIf: ({ isOpen, selectedDueDateIds }) => isOpen || selectedDueDateIds?.length > 0,
              name: 'Text',
              displayValue: ({ }) => 'Filters'
            }
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: '30px', right: '-250px' }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({
                borderRadius: '8px',
                border: '1px solid #E3E3E3',
                background: '#FFFFFF',
                padding: '12px',
                minWidth: '12px',
              }),
              elements: [
                {
                  component: BoxDropdown,
                  name: 'DueDate',
                  bindings: ({ selectedDueDateIds, dueDates }) => {
                    return {
                      label: 'Due Date',
                      icon: WarningTriangleSvg({}),
                      selectedIds: selectedDueDateIds ?? [],
                      entries: dueDates
                    }
                  }
                },
                {
                  component: wrap(Checkbox, P3),
                  name: "HasExportError",
                  bindings: ({ hasExportError }) => {
                  
                    return {
                      label: "Has Export Error",
                      checked: hasExportError,
                    };
                  },
                },
                {
                  component: wrap(wrap(IconTextButton, Mt4), FlexCenterJustifyEndWrapper),
                  name: 'ResetFilters',
                  bindings: ({ }) => ({ icon: TrashBinSvg({}), title: 'Clear filters' })
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);
